module.exports = __webpack_public_path__ + "media/images/goals-6-0b35062c121b1c3f51b451d45f9b1db2.jpg";